import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";
import { ReportStatusUpdate } from "../../shared/interfaces/Result";

export function useUpdateReportStatus(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    mutationKey: ["updateReportStatus"],
    mutationFn: async (reportStatusUpdate: ReportStatusUpdate) =>
      apiContext.utp2ReportsAPIs.updateReportStatus(reportStatusUpdate),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
